import { render } from "./CompanyAssetNote.vue?vue&type=template&id=0212c47b&scoped=true"
import script from "./CompanyAssetNote.vue?vue&type=script&lang=js"
export * from "./CompanyAssetNote.vue?vue&type=script&lang=js"

import "./CompanyAssetNote.vue?vue&type=style&index=0&id=0212c47b&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0212c47b"]])

export default __exports__